import CryptoJS from "crypto-js";

/* const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // return encrypted.toString();
  const ivCiphertext = iv.clone().concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(ivCiphertext);
}

export function decrypt(base64Input) {
  const rawData = CryptoJS.enc.Base64.parse(base64Input);

  // Extract IV and Ciphertext
  const extractedIV = CryptoJS.lib.WordArray.create(
    rawData.words.slice(0, 4),
    16
  ); // 16 bytes IV
  const ciphertext = CryptoJS.lib.WordArray.create(
    rawData.words.slice(4),
    rawData.sigBytes - 16
  );

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
    iv: extractedIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
} */

export const canUserAccess = (user: any, featureCode: string) => {
  return (
    user.locationFeatureArray && user.locationFeatureArray.includes(featureCode)
  );
};

export const setBackgroundBlur = (amount: string) => {
  const root = document.getElementById("root");
  if (root !== null) root.style.filter = `blur(${amount})`;
};

// export const isAdminUser = (user: any, roleId: string) => {
//   return user.roleId.includes(roleId);
// };
